import { useContext } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import AuthContext from "../../../context/auth/AuthContext";
import { createPushNotification } from "../../../services/push-notifications";
import { pushNotificationKeys } from "../queryKeys";

const useCreatePushNotification = () => {
  const { tenant } = useContext(AuthContext);
  const tenantCode = tenant?.code;
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createPushNotification,
    onSuccess: (job) => {
      queryClient.invalidateQueries({
        queryKey: pushNotificationKeys.jobs(tenantCode),
      });
      if (job?.id) {
        queryClient.setQueryData(
          pushNotificationKeys.job(tenantCode, job.id),
          job
        );
      }
    },
  });
};

export default useCreatePushNotification;
